import Header from "./Compartido/Header";
import Hero from "./AltaSocio/Hero";
import Formulario from "./AltaSocio/Formulario";
import Beneficios from "./AltaSocio/Beneficios";
import BrandsSection from "./AltaSocio/BrandsSection";
import Footer from "./Compartido/Footer";

const AltaSocio = (props) => {
    return (
        <>
            <div className="rewards">
                <Header
                    config={props.websgrupo}
                    lang={props.lang}
                    meta_titulo={props.meta_titulo}
                    meta_descripcion={props.meta_descripcion}
                    meta_keywords={props.meta_keywords}
                    ruta={props.ruta}
                    idiomas={props.idiomas}
                    destinos={props.destinos}
                    experiencias={props.experiencias}
                />
                <Hero
                    config={props.websgrupo}
                    ruta={props.ruta}
                />
                <Formulario
                    paises={props.paises}
                    lang={props.lang}
                />
                <Beneficios />
                <app-footer>
                    <BrandsSection
                        lang={props.lang}
                        marcas={props.marcas}
                        ruta={props.ruta}
                    />
                    <Footer
                        lang={props.lang}
                        config={props.websgrupo}
                    />
                </app-footer>
            </div>


        </>
    );
}

export default AltaSocio;
